module.exports = __webpack_public_path__ + "img/hi.f4d1cde7.svg";